<template>
  <v-app class="container">
    <barra />
    <v-card>
      <v-card-title v-if="cargando" class="grey lighten-4 change-font" primary-title>
        <div class="spinner-grow"></div>Cargando pilares &#8230;
      </v-card-title>
      <v-card-title v-else class="grey lighten-4 change-font" primary-title>
        Avance de pilares por punto
        <span
          v-if="gpilares"
          class="d-none d-md-block" style="white-space: pre-wrap;"
        >&nbsp;({{ total }} pilares - {{ totalChilds }} indicadores)</span>
      </v-card-title>
      <v-card-text>
        <v-container v-if="punto">
          <v-layout wrap>
            <v-flex md2 class="d-none d-md-block">
              <img
                width="120px"
                class="mx-auto d-block gray"
                v-bind:src="'data:image/jpeg;base64,' + punto.icono"
              />
            </v-flex>
            <v-flex md10>
              <v-layout>
                <v-menu
                  :open-on-hover="false"
                  :close-on-content-click="true"
                  :offset-x="false"
                  :offset-y="false"
                >
                  <template v-slot:activator="{ on }">
                    <div class="content-title" :style="{ color: punto.color }">
                      {{ punto.nombre }}
                      <v-btn text icon v-on="on">
                        <v-icon>icon-list</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in gpuntos"
                      :key="index"
                      @click="seleccionarpunto(item)"
                    >
                      <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-layout>
              <v-layout justify-center class="d-none d-md-block">{{ punto.descripcion }}</v-layout>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex
              style="margien-top:-55px;"
              s12
              sm6
              md4
              v-for="item of gpilares"
              v-bind:key="item.idpilar"
            >
              <gaugesimple
                v-bind:nombre="'punto6-' + item.idpilar"
                v-bind:id="item.idpilar"
                v-bind:titulo="item.nombre"
                v-bind:fuente="fuente"
                v-bind:vinculo="linkPath + '/' + item.idpunto + '/' + item.idpilar"
              />
            </v-flex>
            <v-flex
              class="fechacorte"
              xs12
              v-if="gfechacorte!== null"
            >Fecha actualización: {{formato(gfechacorte.fechaactualizacion)}}</v-flex>
            <v-flex
              class="fechacorte"
              xs12
              v-if="gfechacorte!== null"
            >Fecha corte: {{formato(gfechacorte.fechacorte)}}</v-flex>
          </v-layout>
        </v-container>
        <p v-else>{{gnodata}}</p>
      </v-card-text>
    </v-card>
<v-tooltip top>
  <template v-slot:activator="{ on: tooltip }">
    <v-layout v-on="tooltip" style="align-self: center;">
    <v-dialog v-model="dialog" width="90%">
      <template  v-slot:activator="{ on: dialogo }">
        
        <v-btn color="primary" dark v-on="dialogo">Visor PDF</v-btn>
        
      </template>
      
      <v-card>
        <v-card-text class="containerdiv Container">
          <h3>{{ArrayTitles[0]}}</h3>
          <div id="divcontainer1" class="gauge1"></div>
          <h3>{{ArrayTitles[1]}}</h3>
          <div id="divcontainer2" class="gauge2"></div>
          <h3>{{ArrayTitles[2]}}</h3>
          <div id="divcontainer3" class="gauge3"></div>
          <h3>{{ArrayTitles[3]}}</h3>
          <div id="divcontainer4" class="gauge4"></div>
          <h3>{{ArrayTitles[4]}}</h3>
          <div id="divcontainer5" class="gauge5"></div>
          <h3>{{ArrayTitles[5]}}</h3>
          <div id="divcontainer6" class="gauge6"></div>
        </v-card-text>
        <v-card-actions>
          
          <v-spacer></v-spacer>
              <v-btn color="green darken-1" v-on="on" text @click="CrearVisorGrafica">Cargar Datos</v-btn>
              <v-btn color="green darken-1" v-on="on" text @click="generarPDF">Exportar</v-btn>
              <v-btn color="green darken-1" v-on="on" text @click="CloseDialog">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
        
    </v-dialog>
      </v-layout>
  </template>
  <span>Se descargarán los tableros de todos los sectores y entidades.</span>
</v-tooltip>
    <v-snackbar v-model="snack" :timeout="5000" :color="MesaggeInfo.color">
      {{this.MesaggeInfo.codigoRespuesta}}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="snack = false">Cerrar</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import gaugesimple from "@/components/chart/gaugetermometro.vue";
import barra from "@/components/content/barra-nav.vue";
import moment from "moment";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);

export default {
  name: "pilar",
  components: {
    gaugesimple,
    barra
  },
  data: function() {
    return {
      dialog: false,
      periodoId: 0,
      cargando: true,
      fuente: "gpilares",
      pilares: null,
      punto: null,
      color: "",
      puntos: [],
      linkPath: "estrategiaz",
      snack: false,
      snackColor: "",
      snackText: "",
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],

      conteoprocesado: 1,
      hiddenesport: true,
      ExtructuraTabla: [],
      ShowFileds: [],
      filtroselect: "",
      periodosselect: "",
      contentpdf: "",
      chart: undefined,
      container: undefined,
      ArrayContainer: [],
      containerGraph: undefined,
      ArrayTitles: [],
      ArrayDescripcion: []
    };
  },
  beforeUpdate() {},
  updated() {},
  created() {
    this.cargarpuntos();
  },
  mounted() {},
  computed: {
    ...mapGetters(["gpilares", "gpilaresall", "gpuntos", "gfechacorte", "gperiododata"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata", "glogo"]),
    ...mapGetters("barra", ["gperiodo", "gbotones"]),
    totalChilds() {
      var t = 0;
      this.gpilares.forEach(element => {
        t += element.indicadores;
      });
      return t;
    },
    total() {
      return this.gpilares.length;
    }
  },
  methods: {
    ...mapActions([
      "get_pilarespunto",
      "get_pilaresallpunto",
      "puntoTodos",
      "get_fechacortepunto",
      "Getperiodo"
    ]),
    cargarpuntos() {
      this.puntoTodos({
        params: {
          periodoId: this.gperiodo
        }
      });
    },
    cargarpilarespunto() {
      if (this.punto !== undefined) {
        this.cargando = true;
        this.get_pilarespunto({
          params: { idpunto: this.punto.idpunto, idperiodo: this.gperiodo },
          data: {}
        });
        this.get_pilaresallpunto({
          params: { idpunto: 0, idperiodo: this.gperiodo },
          data: {}
        });
        this.get_fechacortepunto({
          params: {
            idperiodo: this.gperiodo,
            idpunto: this.punto.idpunto
          }
        });
      }
    },
    formato(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    seleccionarpunto(b) {
      this.punto = b;
    },
    Llenarextrcuturatabla(VarEntidades) {
      this.ExtructuraTabla = [];
      this.gpuntos.forEach(element => {
        let arraypilares = [];
        let ElementsAgrupados = VarEntidades.filter(record => {
          if (record.idpunto == element.idpunto) {
            return record;
          }
        });
        if (ElementsAgrupados != undefined) {
          ElementsAgrupados.forEach(elementgroup => {
            this.ExtructuraTabla.push({
              idpunto: element.idpunto,
              nombrepunto: element.nombre,
              descripcion: element.descripcion,
              pilar: {
                nombre: elementgroup.nombre,
                valor: elementgroup.avance,
                color: elementgroup.color,
                conteoestrategias: elementgroup.estrategias,
                conteoindicadores: elementgroup.indicadores,
                grafica: ""
              }
            });
          });
        }
      });
    },
    AgregarGafica(valor, color, nombrepilar, contest, contind, titulopilar) {
      let Retunstring = undefined;
      if (!isNaN(valor)) {
        if (valor >= 0) {
          Retunstring = this.AgregarChart(
            valor,
            color,
            nombrepilar,
            contest,
            contind,
            titulopilar
          );
        }
      }
      return Retunstring;
    },
    asignarSGV() {
      this.gpuntos.forEach(element => {
        let EntidadFiltrada = this.ExtructuraTabla.filter(record => {
          if (record.idpunto == element.idpunto) {
            return record;
          }
        });
        //this.containerExport = am4core.create("divcontainer1", am4core.Container);
        this.ArrayTitles.push(EntidadFiltrada[0].nombrepunto);
        this.ArrayDescripcion.push(EntidadFiltrada[0].descripcion)

        this.containerGraph = am4core.create(
          "divcontainer" + EntidadFiltrada[0].idpunto,
          am4core.Container
        );
        //this.containerGraph = this.container.createChild(am4core.Container);
        this.containerGraph.background.fill = am4core.color("#FFFFFF");

        this.containerGraph.width = am4core.percent(100);
        
        this.containerGraph.layout = "grid";

        EntidadFiltrada.forEach(element => {
          element.pilar.grafica = this.AgregarGafica(
            element.pilar.valor,
            element.pilar.color,
            element.pilar.nombre,
            element.pilar.conteoestrategias,
            element.pilar.conteoindicadores,
            element.nombrepunto
          );
        });
        this.ArrayContainer.push(this.containerGraph);
      });
    },
    CrearVisorGrafica() {
      // this.container = am4core.create("divcontainer", am4core.Container);
      // this.container.width = am4core.percent(100);
      // this.container.layout = "vertical";

      // // // Enable export
      // this.container.exporting.menu = new am4core.ExportMenu();

      this.asignarSGV();
    },
    AgregarChart(valor, color, titulopilar, contest, contind, titulopunto) {
      var chart = this.containerGraph.createChild(am4charts.GaugeChart);
      chart.background.fill = am4core.color("#FFFFFF");
      chart.width = am4core.percent(50);
      chart.height = 300;

      chart.innerRadius = am4core.percent(90);
      chart.startAngle = -190;
      chart.endAngle = 10;

      /**
       * datos basicos para la grafica
       */
      var axis = chart.xAxes.push(new am4charts.ValueAxis());
      axis.min = 0;
      axis.max = 100;
      axis.renderer.radius = am4core.percent(90);
      axis.renderer.labels.template.fontSize = 10;
      //  creamos una sombra para darle efecto a la grafica.
      let shadow = axis.filters.push(new am4core.DropShadowFilter());
      shadow.dx = 1;
      shadow.dy = 1;
      shadow.blur = 2;
      shadow.opacity = 0.5;

      /**
       * contiene los 2 rangos el de color que indica el valor y el gris que indica el valor restante
       */
      let rgm = new am4core.RadialGradientModifier();
      rgm.brightnesses.push(-0.1, -0.1, -0.1, 0, -0.9);
      var fillModifier = new am4core.LinearGradientModifier();
      fillModifier.radius = true;
      fillModifier.brightnesses = [0, 0, 0, 0];
      fillModifier.offsets = [0, 0.45, 0.55, 1];

      this.range0 = axis.axisRanges.create();
      this.range0.value = 0;
      this.range0.endValue = valor;
      this.range0.axisFill.fillOpacity = 1;
      this.range0.axisFill.fill = am4core.color(color);
      this.range0.axisFill.fillModifier = fillModifier;
      this.range0.axisFill.zIndex = -1;

      var range1 = axis.axisRanges.create();
      range1.value = 0;
      range1.endValue = 100;
      range1.axisFill.fillOpacity = 1;
      range1.axisFill.fill = am4core.color("#ededed");
      range1.axisFill.zIndex = -2;

      // /**
      //  * contiene el Texto inteno de la grafica, da el procentaje
      //  */

      this.label = chart.radarContainer.createChild(am4core.Label);
      this.label.isMeasured = false;
      this.label.fontSize = 20;
      this.label.horizontalCenter = "middle";
      this.label.verticalCenter = "bottom";
      this.label.fill = am4core.color(color);
      this.label.text =
        Intl.NumberFormat("es-CO", { minimumFractionDigits: 1 }).format(valor) +
        " %";
      this.label.y = 30;

      this.Contenido = chart.radarContainer.createChild(am4core.Label);
      this.Contenido.isMeasured = false;
      this.Contenido.fontSize = 12;
      this.Contenido.horizontalCenter = "middle";
      this.Contenido.y = 35;
      this.Contenido.text =
        "(" + contest + " Estrategias - " + contind + " Indicadores)";

      var Title = chart.radarContainer.createChild(am4core.Label);
      Title.isMeasured = false;
      Title.fontSize = 16;
      Title.horizontalCenter = "middle";
      Title.text = titulopilar;
      Title.maxHeight = 400;
      Title.wrap = true;
      Title.maxWidth = 300;
      //Title.truncate = true;
      Title.y = 55;

      this.hand = chart.hands.push(new am4charts.ClockHand());
      this.hand.axis = axis;
      this.hand.innerRadius = am4core.percent(30);
      this.hand.startWidth = 10;
      this.hand.pin.disabled = true;
      this.hand.value = valor;
    },
    
    generarPDF() {
      let imagen = this.glogo;
      let fecha = this.$getFormattedDate();

      this.gbotones.forEach(element => {
        if (element.state == true) {
          this.filtroselect = element.caption;
        }
      });

      this.periodosselect = "";
      if (this.gperiododata.nombre != undefined) {
        this.periodosselect = " => " + this.gperiododata.nombre;
      }

      var doc = {
        pageSize: "A4",
        pageOrientation: "portrait",
        pageMargins: [30, 30, 30, 30],
        content: [],
        styles: {
          tableStyle: {
            width: "100%"
          },
          header: {
            fontSize: 20,
            bold: true,
            alignment: "center"
          },
          subheader: {
            fontSize: 18,
            bold: true,
            alignment: "left"
          },
          tableHeader: {
            bold: true,
            fontSize: 14,
            color: "black",
            alignment: "center",
            "background-color": "#4CAF50"
          },
          textfilter: {
            fontSize: 15,
            bold: false,
            alignment: "right"
          }
        },
        footer: function(currentPage, pageCount) {
          return [
            {
              text: fecha,
              alignment: "left",
              margin: [10, 0],
              fontSize: 8
            },
            {
              text: "Página " + currentPage.toString() + " de " + pageCount,
              alignment: "right",
              margin: [10, 0],
              fontSize: 8
            }
          ];
        }
      };

      doc.content.push({
        image: imagen,
        width: 150
      });

      doc.content.push({
        text: "Avance de pilares por punto \n\n",
        style: "header"
      });

      doc.content.push({
        text: "Filtros:  " + this.filtroselect + " " + this.periodosselect,
        style: "textfilter"
      });

      let titletest = this.ArrayTitles;
      let descripciones = this.ArrayDescripcion;
      Promise.all([
        this.ArrayContainer[0].exporting.pdfmake,
        this.ArrayContainer[0].exporting.getImage("png"),
        this.ArrayContainer[1].exporting.getImage("png"),
        this.ArrayContainer[2].exporting.getImage("png"),
        this.ArrayContainer[3].exporting.getImage("png"),
        this.ArrayContainer[4].exporting.getImage("png"),
        this.ArrayContainer[5].exporting.getImage("png")
      ]).then(function(res) {
        var pdfMake = res[0];

        doc.content.push({
          text: titletest[0],
          fontSize: 16,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10]
        });

        doc.content.push({
          text: descripciones[0],
          fontSize: 10,
          bold: false,
          alignment: "left",
          margin: [0, 0, 0, 0]
        });

        doc.content.push({
          image: res[1],
          width: 280,
          alignment: "center",
          pageBreak: "after"
        });

        doc.content.push({
          text: titletest[1],
          fontSize: 16,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10]
        });

        doc.content.push({
          text: descripciones[1],
          fontSize: 10,
          bold: false,
          alignment: "left",
          margin: [0, 0, 0, 0]
        });

        doc.content.push({
          image: res[2],
          width: 300,
          alignment: "center",
          pageBreak: "after"
        });

        doc.content.push({
          text: titletest[2],
          fontSize: 16,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10]
        });

        doc.content.push({
          text: descripciones[2],
          fontSize: 10,
          bold: false,
          alignment: "left",
          margin: [0, 0, 0, 10]
        });        

        doc.content.push({
          image: res[3],
          width: 300,
          alignment: "center",
          pageBreak: "after"
        });

        doc.content.push({
          text: titletest[3],
          fontSize: 16,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10]
        });

        doc.content.push({
          text: descripciones[3],
          fontSize: 10,
          bold: false,
          alignment: "left",
          margin: [0, 0, 0, 0]
        });        

        doc.content.push({
          image: res[4],
          width: 300,
          alignment: "center",
          pageBreak: "after"
        });

        doc.content.push({
          text: titletest[4],
          fontSize: 16,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10]
        });

        doc.content.push({
          text: descripciones[4],
          fontSize: 10,
          bold: false,
          alignment: "left",
          margin: [0, 0, 0, 0]
        });

        doc.content.push({
          image: res[5],
          width: 300,
          alignment: "center",
          pageBreak: "after"
        });

        doc.content.push({
          text: titletest[5],
          fontSize: 16,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10]
        });

        doc.content.push({
          text: descripciones[5],
          fontSize: 10,
          bold: false,
          alignment: "left",
          margin: [0, 0, 0, 0]
        });        

        doc.content.push({
          image: res[6],
          width: 300,
          alignment: "center"
        });
        pdfMake.createPdf(doc).download("report.pdf");
      });
    }, 
    CloseDialog(){
      this.dialog = false;
      this.containerGraph = [];
      this.chart = [];
      this.Container = [];
      this.ArrayTitles = [];
      this.ArrayContainer = [];
      this.containerGraph = am4core.create("divcontainer1",am4core.Container);
      this.containerGraph = am4core.create("divcontainer2",am4core.Container);
      this.containerGraph = am4core.create("divcontainer3",am4core.Container);
      this.containerGraph = am4core.create("divcontainer4",am4core.Container);
      this.containerGraph = am4core.create("divcontainer5",am4core.Container);
      this.containerGraph = am4core.create("divcontainer6",am4core.Container);
    }
  },
  watch: {
    gperiodo: function() {
      this.cargarpilarespunto();
      this.Getperiodo({
        params: {
          idperiodo: this.gperiodo
        }
      });
    },
    punto: function() {
      this.cargarpilarespunto();
    },
    gpuntos: function() {
      this.puntos = this.gpuntos;
      this.punto = this.puntos.filter(
        record => record.idpunto == this.$route.params.idpunto
      )[0];
    },
    gpilares: function() {
      this.cargando = false;
      this.pilares = this.gpilares;
    },
    gpilaresall: function() {
      
      this.Llenarextrcuturatabla(this.gpilaresall);
    },
    ginformation() {
      this.cargando = false;
      this.MesaggeInfo = this.ginformation;
      this.snack = true;
    },
    conteoprocesado() {
      if (this.ArrayContainer.length == this.conteoprocesado) {
        this.hiddenesport = false;
        this.conteoprocesado = 0;
      }
    }
  }
};
</script>

<style scoped>
.gauge1 {
  width: 100%;
  height: 1500px;
}
.gauge2 {
  width: 100%;
  height: 600px;
}
.gauge3 {
  width: 100%;
  height: 600px;
}
.gauge4 {
  width: 100%;
  height: 600px;
}
.gauge5 {
  width: 100%;
  height: 600px;
}
.gauge6 {
  width: 100%;
  height: 1000px;
}
.containerdiv {
  width: 100%;
  height: 400px;
  overflow: scroll;
}
</style>